exports.list = {
    path: '/import_data',
    name: 'import_data', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/import_data/List.vue"),
  }
  